const whitelist = ['auth', 'app', 'vaultCache', 'photos'];
export default whitelist;
